module.exports = __webpack_public_path__ + "static/img/sg1.286a6f3.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/role3/control2/sg1.png
// module id = mqK3
// module chunks = 7